import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'what_brings_you_here'

const OPTIONS = [
  { value: 'good', translationKey: 'pages.onboarding.reason.options.good' },
  {
    value: 'cutting-back',
    translationKey: 'pages.onboarding.reason.options.cutting-back',
  },
  {
    value: 'curious',
    translationKey: 'pages.onboarding.reason.options.curious',
  },
  {
    value: 'someone-i-care-about',
    translationKey: 'pages.onboarding.reason.options.someone-i-care-about',
  },
  {
    value: 'exploring',
    translationKey: 'pages.onboarding.reason.options.exploring',
  },
]

const ANSWER_TEXTS = {
  good: 'I want to quit for good',
  'cutting-back': "I'm cutting back",
  curious: "I'm curious if I can do it",
  'someone-i-care-about': 'Someone I care about wants me to stop',
  exploring: 'Just exploring',
}

export default function VisitReasonPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What brings you here today?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.reason.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
